// Eyebrow — tiny uppercase label that sits above a title/section. Tone tints
// the text to a semantic color. From the prototype's m2-eyebrow.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './eyebrow.css';

export function Eyebrow({ tone, className, children, ...rest }) {
  return (
    <span className={cx('eyebrow', tone && `eyebrow--${tone}`, className)} {...rest}>
      {children}
    </span>
  );
}

Eyebrow.propTypes = {
  tone: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'purple']),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Eyebrow;
